import projectListService from './services/projects.service';

export const PROJECTS = 'project/PROJECTS';
export const CREATE_PROJECT = 'project/CREATE_PROJECT';
export const UPDATE_PROJECT = 'project/UPDATE_PROJECT';
export const DELETE_PROJECT = 'project/DELETE_PROJECT';

const initialState = {
  list: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PROJECT: {
      const projectList = action.payload;
      state.list.push(projectList);
      
      return state;
    }
    case UPDATE_PROJECT: {
      const profileData = action.payload;
      const index = state.list.findIndex(({id}) => id === profileData.id);

      if (index > -1) {
        state.list[index] = profileData;
      }
      
      return state;
    }
    case PROJECTS: {
      return {
        ...state,
        list: action.payload
      };
    }
    case DELETE_PROJECT: {
      const projectId = action.payload;
      const projectsList = state.list.slice();
      const index = projectsList.findIndex(({id}) => id === projectId);

      if (index > -1) {
        projectsList.splice(index, 1);
      }

      return {
        ...state,
        list: projectsList
      };
    }
    default:
      return state
  }
}

export const loadProjectList = () => {
  return (dispatch, getState) => {
    return projectListService.getProjects()
      .then((projectList) => {
        dispatch({
          type: PROJECTS,
          payload: projectList
        });

        return projectList;
      });
  };
};

export const createProject = (projectData) => {
  return (dispatch, getState) => {
    return projectListService.createProject(projectData)
      .then((project) => {
        dispatch({
          type: CREATE_PROJECT,
          payload: project
        });

        return project;
      });
  };
};

export const updateProject = (projectId, projectData) => {
  return (dispatch, getState) => {
    return projectListService.updateProject(projectId, projectData)
      .then((project) => {
        dispatch({
          type: UPDATE_PROJECT,
          payload: project
        });

        return project;
      });
  };
};

export const deleteProject = (projectId) => {
  return (dispatch, getState) => {
    return projectListService.deleteProject(projectId)
      .then((project) => {
        dispatch({
          type: DELETE_PROJECT,
          payload: projectId
        });

        return project;
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/projects.js